import React, {Component, ReactNode} from 'react'
import {Box, DialogContent} from '@mui/material'
import {AdminPageHeadingArea} from '../shared/pageBaseComponents/AdminPageHeadingArea'
import {AdminPrimaryButton} from '../../styledComponents/adminPage/Buttons'
import {Nullable} from '../../app/TypeHelpers'
import {LeftRowFlexContainer} from '../../styledComponents/FlexComponents'
import PPDatePicker from '../shared/forms/PPDatePicker'
import PPRadioGroup from '../shared/forms/PPRadioGroup'
import {AVAILABLE_OR_NOT} from '../../CodeMaster'
import {BackLink} from '../../styledComponents/adminPage/Links'
import {NotifyDialogActions, NotifyDialogTitle} from './AssocDirectorCommon'

interface Props {
    eventDate: Nullable<Date>
    attendanceReplyDeadline: Nullable<Date>
    proxyAttendanceAvailability: Nullable<string>
    onNext: () => void
    onClose: () => void
    onChange: (attendanceReplyDeadline: Nullable<Date>, proxyAttendanceAvailability: Nullable<string>) => void
}

export class AdminMeetingAttendanceReplyRequestDialog extends Component<Props> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleChangeAttendanceReplyDeadline = this.handleChangeAttendanceReplyDeadline.bind(this)
        this.handleChangeProxyAttendanceAvailability = this.handleChangeProxyAttendanceAvailability.bind(this)
    }

    handleChangeAttendanceReplyDeadline(attendanceReplyDeadline: Nullable<Date>): void {
        this.props.onChange(
            attendanceReplyDeadline,
            this.props.proxyAttendanceAvailability,
        )
    }

    handleChangeProxyAttendanceAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.onChange(
            this.props.attendanceReplyDeadline,
            event.target.value,
        )
    }

    render(): ReactNode {
        const {eventDate, attendanceReplyDeadline, proxyAttendanceAvailability, onClose, onNext} = this.props
        const nextDisabled = attendanceReplyDeadline === null || proxyAttendanceAvailability === null
        return <Box width={'750px'}>
            <NotifyDialogTitle>
                <AdminPageHeadingArea title={'出欠回答依頼(1/2)'} onClose={onClose}/>
            </NotifyDialogTitle>
            <DialogContent>
                <Box>
                    メンバーに向けて、出欠回答を依頼します。回答期限と代理出席可否を設定してください。
                </Box>
                <Box m={'15px'}>
                    <LeftRowFlexContainer>
                        <label>回答期限：</label>
                        <Box width={'15px'}/>
                        <PPDatePicker
                            value={attendanceReplyDeadline}
                            maxDate={eventDate}
                            onChangeDate={this.handleChangeAttendanceReplyDeadline}
                        />
                    </LeftRowFlexContainer>
                    <LeftRowFlexContainer>
                        <label>代理出席：</label>
                        <Box width={'15px'}/>
                        <PPRadioGroup
                            row
                            data={[
                                {label: '許可する', value: AVAILABLE_OR_NOT.AVAILABLE.value},
                                {label: '許可しない', value: AVAILABLE_OR_NOT.UNAVAILABLE.value},
                            ]}
                            value={proxyAttendanceAvailability}
                            onChange={this.handleChangeProxyAttendanceAvailability}
                        />
                    </LeftRowFlexContainer>
                    <LeftRowFlexContainer>
                        <Box width={'100px'}/>
                        ※許可した場合、出欠回答時の選択肢として「出席」「欠席」の他に<br/>
                        「代理出席」が追加されます。
                    </LeftRowFlexContainer>
                </Box>
            </DialogContent>
            <NotifyDialogActions>
                <BackLink onClick={onClose}>
                    キャンセル
                </BackLink>
                <Box width={'50px'}/>
                <AdminPrimaryButton onClick={onNext} disabled={nextDisabled}>送信内容の確認に進む</AdminPrimaryButton>
            </NotifyDialogActions>
        </Box>
    }
}
